import moment from 'moment-timezone';
import CampaignModel from 'cio/models/campaign';
import DeliveryModel from 'cio/models/delivery';

export default function isExpiredDeliveryInEventTriggeredCampaign(
  delivery: DeliveryModel,
  campaign: CampaignModel | null,
): boolean {
  if (campaign == null || !campaign.isEventTriggered) {
    return false;
  }

  // The backend does not store events data older than 30 days.
  return moment.unix(delivery.created).isBefore(moment().subtract(30, 'days'));
}
